export default "__VITE_ASSET__3JSKQ9pM__"